import app from "flarum/forum/app";
import Notification from "flarum/forum/components/Notification";
import { channelIdOf, channelNameOf, fromName, openChannelFromNotification } from "./ModeratorPromotedNotification";

/**
 * "X declined to take over #channel." Sent to whoever offered the channel, so
 * a refusal is an answer rather than an offer that quietly stopped pending.
 */
export default class OwnershipTransferDeclinedNotification extends Notification {
  icon() {
    return "fas fa-user-xmark";
  }
  href() {
    const channelId = channelIdOf(this);
    return channelId ? app.route("chat.channel", {
      id: channelId
    }) : app.route("chat.index");
  }
  content() {
    return app.translator.trans("ramon-chat.forum.notifications.ownership_transfer_declined", {
      username: fromName(this),
      channel: channelNameOf(this)
    });
  }
  excerpt() {
    return null;
  }
  onclick(e) {
    openChannelFromNotification(this, e);
  }
}
flarum.reg.add('ramon-chat', 'forum/components/OwnershipTransferDeclinedNotification', OwnershipTransferDeclinedNotification);